import { useEffect, useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const useNonEmptyPrevious = <T extends unknown>(
  value: T
): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    if (value) {
      ref.current = value;
    }
  }, [value]);
  return ref.current;
};
